import type { JSX } from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useGetCtaImage } from './hooks/useGetCtaImage';

export function MembersCta(): JSX.Element {
	const {
		data: { imageUrl },
	} = useGetCtaImage();

	if (!imageUrl) {
		return (
			<div className="bg-gradient-background-light-2 py-20">
				<div className="container">
					<div className="mx-auto flex max-w-lg flex-col items-center justify-center gap-4 text-center">
						<Text as="h2" variant="heading" size="large">
							<Translate value="fe.pages.impact.membership.title" />
						</Text>
						<Text as="p">
							<Translate value="fe.pages.impact.membership.description" />
						</Text>
						<Button
							as="a"
							href="/member"
							className="mt-4 w-full md:w-auto"
							variant="primary"
							data-qa="become-member-button"
						>
							<Translate value="fe.pages.impact.membership.become_a_member_action" />
						</Button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="bg-gradient-background-light-2 pt-20">
			<div className="container">
				<div className="flex flex-col justify-center md:flex-row">
					<div>
						<Text as="h2" variant="heading" size="large" className="mt-0 md:mt-10">
							<Translate value="fe.pages.impact.membership.title" />
						</Text>
						<Text as="p" className="mt-4 max-w-2xl">
							<Translate value="fe.pages.impact.membership.description" />
						</Text>
						<Button
							as="a"
							href="/member"
							className="mt-4 w-full md:w-auto"
							variant="primary"
							data-qa="become-member-button"
						>
							<Translate value="fe.pages.impact.membership.become_a_member_action" />
						</Button>
					</div>
					<Image src={imageUrl} alt="" className="aspect-auto grow basis-0" />
				</div>
			</div>
		</div>
	);
}
